import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router)
  const authService = inject(AuthService)
  if (authService.isAuthValid()) {
    return true
  } else {
    authService.logout()
    // Store the full URL the user was trying to access, ensuring we capture query params
    // but only if it's not the home page
    const fullUrl = state.url
    if (fullUrl !== '/' && fullUrl !== '') {
      console.log('Storing redirect URL:', fullUrl) // Debug log
      localStorage.setItem('redirectUrl', fullUrl)
    } else {
      console.log('On home page, no redirect URL will be saved')
      localStorage.removeItem('redirectUrl')
    }
    router.navigate([{ outlets: { modal: 'auth' } }], {
      skipLocationChange: true,
    })
    return false
  }
}
